import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1347ef6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full px-5 pb-2 h-96 overflow-auto" }
const _hoisted_2 = { class: "grid grid-flow-row auto-rows-max" }
const _hoisted_3 = { class: "col-span-12 border-l-4 font-bold border-infoColor text-infoColor mb-2" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = { class: "flex flex-wrap" }
const _hoisted_7 = { class: "relative pb-2" }
const _hoisted_8 = { class: "grid grid-flow-row auto-rows-max" }
const _hoisted_9 = { class: "absolute z-10 text-black" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "p-2" }
const _hoisted_12 = { class: "w-48 p-2" }
const _hoisted_13 = { class: "font-black" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = { class: "col-span-12" }
const _hoisted_18 = { class: "font-bold pr-4" }
const _hoisted_19 = { class: "font-bold pr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_MdRemove = _resolveComponent("MdRemove")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_MdPerson = _resolveComponent("MdPerson")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseGroupList, (responseList) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-span-12 mt-3",
          key: responseList.week
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "  " + _toDisplayString(responseList.week), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responseList.items, (col) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mr-1",
                  key: col.EventScheduleId
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_n_checkbox, {
                              class: "w-full",
                              checked: col.Status === _ctx.ParamResponseStatus.Agree,
                              onClick: ($event: any) => (_ctx.userVote(_ctx.event?.EventHeaderId ?? '',
                              col?.EventScheduleId ?? '',
                              col.EventParticipantId,
                              col.ParticipantResponseId ?? '',
                              col.Status === _ctx.ParamResponseStatus.Agree? _ctx.ParamResponseStatus.Deny: _ctx.ParamResponseStatus.Agree
                              )),
                              disabled: _ctx.resNone.Status === _ctx.ParamParticapantStatus.None,
                              style: _normalizeStyle({'--color-checked': _ctx.themeVars.infoColor, '--border-checked': '1px solid' + _ctx.themeVars.infoColor, '--border-focus': _ctx.themeVars.infoColor, '--border:': _ctx.themeVars.infoColor})
                            }, null, 8, ["checked", "onClick", "disabled", "style"])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.dateDisplay(col.ScheduleStartUTCDateTime).indexOf("W") === -1 ? _ctx.dateDisplay(col.ScheduleStartUTCDateTime) + " " : _ctx.dateDisplay(col.ScheduleStartUTCDateTime)), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.startTimeDisplay(col.ScheduleStartUTCDateTime)) + " ", 1),
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_MdRemove)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.endTimeDisplay(col.ScheduleEndUTCDateTime)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.eventResponseFilter(col?.EventScheduleId ?? '')!=='')
                              ? (_openBlock(), _createBlock(_component_n_popover, {
                                  key: 0,
                                  trigger: "hover"
                                }, {
                                  trigger: _withCtx(() => [
                                    _createVNode(_component_n_button, { quaternary: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_n_icon, { class: "text-xl" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_MdPerson)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" x " + _toDisplayString(col.AgreeCount), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                      _createVNode(_component_n_tag, { type: "warning" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('replied')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.eventResponseFilter(col?.EventScheduleId ?? '')), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_n_button, { quaternary: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_n_icon, { class: "text-xl" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_MdPerson)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" x " + _toDisplayString(col.AgreeCount), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_n_progress, {
                          type: "line",
                          percentage: _ctx.percentage(col.AgreeCount, _ctx.event?.HeadCount ?? 1),
                          height: 36,
                          "border-radius": 4,
                          "fill-border-radius": 0,
                          "show-indicator": false,
                          color: 
                          col.Status === _ctx.ParamResponseStatus.Agree
                          ?_ctx.changeColor(_ctx.themeVars.warningColor,{ alpha: 1 })
                          :_ctx.changeColor(_ctx.themeVars.buttonColor2,{ alpha: 0.4 }),
                          class: "w-72",
                          "rail-color": 
                          _ctx.changeColor(
                            col.Status === _ctx.ParamResponseStatus.Agree
                              ? _ctx.themeVars.warningColor
                              : _ctx.themeVars.buttonColor2,
                            { alpha: 0.2 }
                          )
                        
                        }, null, 8, ["percentage", "color", "rail-color"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_n_checkbox, {
          type: "warning",
          checked: _ctx.resNone.Status === _ctx.ParamParticapantStatus.None,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voteNone(_ctx.resNone, _ctx.resNone.Status === _ctx.ParamParticapantStatus.None ? _ctx.ParamParticapantStatus.Open: _ctx.ParamParticapantStatus.None))),
          height: 36,
          "border-radius": 4,
          class: "font-bold px-2 mt-3 rounded bg-buttonColor2Pressed",
          style: _normalizeStyle({'--color-checked': _ctx.themeVars.infoColor, '--border-checked': '1px solid' + _ctx.themeVars.infoColor, '--border-focus': _ctx.themeVars.infoColor, '--border:': _ctx.themeVars.infoColor})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_space, null, {
              default: _withCtx(() => [
                (_ctx.personNone.count > 0)
                  ? (_openBlock(), _createBlock(_component_n_popover, {
                      key: 0,
                      trigger: "hover"
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(_component_n_button, { quaternary: "" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('NoneOfTheAbove')), 1),
                            _createVNode(_component_n_icon, { class: "text-xl" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_MdPerson)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" x " + _toDisplayString(_ctx.personNone.count), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createVNode(_component_n_tag, { type: "warning" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('replied')), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.personNone.name), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_n_button, {
                      key: 1,
                      quaternary: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t('NoneOfTheAbove')), 1),
                        _createVNode(_component_n_icon, { class: "text-xl" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MdPerson)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" x " + _toDisplayString(_ctx.personNone.count), 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["checked", "style"])
      ])
    ])
  ]))
}